<template>
  <div>
    <div class="card-body">
        <b-row>
          <b-col md="12">
            <div class="pull-right">
              <b-button v-b-modal.modalUsers variant="themecolor" size="sm" @click.stop="loadModal(null)">{{$t('buttons.toevoegen')}}</b-button>
            </div>
          </b-col>
        </b-row>
        <b-table show-empty :items="users" :fields="fields" v-if="users" :empty-text="getEmptyText(count)" :busy="count == -1">
        <template v-slot:cell(emailAddress)="row">
          {{row.value.address}}
        </template>
        <template v-slot:cell(actions)="row">
          <b-button v-b-modal.modalUsers variant="themecolor" size="sm" @click.stop="loadModal(row.item)">
            <i class="fa fa-edit" aria-hidden="true"></i>
          </b-button>
          <delete title="Gebruiker" 
              :noRedirect="true" 
              :hideText="true" 
              :id="row.item.id" 
              namespace="management" 
              resource="users" />
        </template>
        <template v-slot:table-busy>
          <PreLoader/>
        </template>
      </b-table>
    </div>
    <!-- Modal Component -->
    <b-modal id="modalUsers" ref="users" :title="`${$t('datatables.gebruiker')} ${command.id ? $t('klantrelaties.bewerker') : $t('klantrelaties.aanmaker')}`" 
      hide-footer centered :cancel-title="$t('buttons.annuleren')" ok-variant="themecolor" :ok-title="$t('buttons.opslaan')">
      <b-form @submit="onSubmit" autocomplete="off">
        <!-- Form content -->
        <b-form-group :label="$t('datatables.emailadres')" label-for="email_address">
            <b-form-input id="email_address" v-model="command.emailAddress" type="email" :placeholder="$t('datatables.emailadres')" />
            <validation element="email_address" />
        </b-form-group>
        <b-form-group :label="$t('datatables.voornaam')" label-for="first_name">
            <b-form-input id="first_name" v-model="command.firstName" type="text" :placeholder="$t('datatables.voornaam')" />
            <validation element="first_name" />
        </b-form-group>
        <b-form-group :label="$t('datatables.achternaam')" label-for="last_name">
            <b-form-input id="last_name" v-model="command.lastName" type="text" :placeholder="$t('datatables.achternaam')" />
            <validation element="last_name" />
        </b-form-group>
        <b-form-group :label="$t('datatables.rol')" label-for="role">
            <b-form-select id="role" v-model="command.role" type="text" :placeholder="$t('datatables.rol')">
                <b-form-select-option value="0">---Selecteer---</b-form-select-option>
                <b-form-select-option value="1">Accordeur</b-form-select-option>
                <b-form-select-option value="2">Beheerder</b-form-select-option>
            </b-form-select>
        </b-form-group>
        <!-- Form content -->
        <hr/>
        <!-- Submit controls -->
        <b-row>
            <b-col md="12">
                <b-button @click="$refs.users.hide()" variant="secondary">{{$t('buttons.annuleren')}}</b-button>
                <b-button type="submit" variant="themecolor">{{$t('buttons.opslaan')}}</b-button>
            </b-col>
        </b-row>
        <!-- Submit controls -->
      </b-form>
    </b-modal>
    <!-- Modal Component -->
  </div>
</template>
<script>
//Import store
import { mapGetters, mapActions } from 'vuex'
import PreLoader from '@/components/root/Preloader';
import { getEmptyText } from '@/views/root/GetMessageTextHelper';
//Import command
import Command from './command'

export default {
    name: 'users',
    components: {PreLoader},
    data () {
      return {
        command: {},
        count: -1,
      }
    },
    computed: {
      fields() {
        return [
            { key: 'firstName', label: this.$i18n.t('datatables.voornaam'), sortable: true },
            { key: 'lastName', label: this.$i18n.t('datatables.achternaam'), sortable: true },
            { key: 'emailAddress', label: this.$i18n.t('datatables.emailadres'), sortable: true },
            { key: 'actions', label: this.$i18n.t('datatables.acties') }
        ]
      },
      ...mapGetters ('management',['users'])
    },
    methods: {
      ...mapActions('management',['all','create','update','delete']),
      loadModal(item) {
        var vm = this;
        vm.$store.dispatch('errors/clearErrors');
        vm.command = new Command(item);
      },
      onSubmit (event) {
        event.preventDefault();
        var vm = this;
        var payload = {
            resource: 'users',
            path: vm.$route.path,
            params: vm.command
        };
        
        var action = vm.command.id ? vm.update(payload) : vm.create(payload);
        action.then(()=> {
              vm.$refs.users.hide();
        })
      },
      getEmptyText,
    },
    created() {
      var vm = this;
      vm.all({
        resource: 'users'
      })
      .then((data) => {
        vm.count = data.result.length;
      });
    }
}
</script>